import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import {
	administrationAccount,
	administrationSite,
	appManagement,
	dashboardMenu,
	demoPages,
	documentsPlayer,
	matchManagements,
	matchStatisticsManage,
	shopManagementUser,
	userTeam,
} from '../menu';
import Login from '../pages/presentation/auth/Login';
import Register from '../pages/presentation/auth/Register';
import ForgottenPassword from '../pages/presentation/auth/ForgottenPassword';
import VerifyAccount from '../pages/presentation/auth/VerifyAccount';
import BeerIndexWallGate from '../pages/bar/BeerIndexWallGate';

const LANDING = {
	DASHBOARD: lazy(() => import('../pages/dashboard/DashboardPage')),
	YOUTUBE_LIVE: lazy(() => import('../pages/dashboard/YoutubeLivePage')),
	USERS: lazy(() => import('../pages/dashboard/app-administration/Users')),
	NEWSLETTER: lazy(() => import('../pages/dashboard/app-administration/Newsletter')),
	TRANSFERS: lazy(() => import('../pages/dashboard/app-administration/Transfers')),
	TEAMS: lazy(() => import('../pages/dashboard/app-administration/Teams')),
	COMPETITIONS: lazy(
		() => import('../pages/dashboard/app-administration/competitions/Competitions'),
	),
	CUP_MANAGEMENT: lazy(() => import('../pages/dashboard/app-administration/cup/CupManagement')),
	TOUR_MANAGEMENT: lazy(() => import('../pages/dashboard/app-administration/cup/TourManagement')),
	TOUR_ADMINISTRATION: lazy(
		() => import('../pages/dashboard/app-administration/cup/TourAdministration'),
	),
	EDITIONS: lazy(() => import('../pages/dashboard/app-administration/competitions/Editions')),
	EDITION_JOURNAL: lazy(
		() => import('../pages/dashboard/app-administration/edition-journal/EditionJournal'),
	),
	LEAGUES: lazy(() => import('../pages/dashboard/app-administration/competitions/Leagues')),
	ADMINISTRATE_LEAGUE: lazy(
		() => import('../pages/dashboard/app-administration/competitions/AdministrateLeague'),
	),
	DISCIPLINARY: lazy(
		() => import('../pages/dashboard/app-administration/disciplinary/Disciplinary'),
	),
	MATCH_STATISTICS: lazy(
		() => import('../pages/dashboard/app-administration/match-statistics/MatchStatistics'),
	),
	GENERAL_SETTINGS: lazy(() => import('../pages/dashboard/app-administration/GeneralSettings')),
	CRM_PAGE: lazy(() => import('../pages/dashboard/app-administration/crm/CrmPage')),
	FINANCIAL: lazy(() => import('../pages/dashboard/app-administration/Financial')),
	MATCH_EVENTS: lazy(
		() => import('../pages/dashboard/app-administration/match-events/MatchEvents'),
	),
	MATCH_EVENT_DETAILS: lazy(
		() => import('../pages/dashboard/app-administration/match-events/MatchEventsDetails'),
	),
	LINEUP: lazy(() => import('../pages/dashboard/app-administration/match-events/Lineup')),
	NEWS: lazy(() => import('../pages/dashboard/website/media/News')),
	INTERVIEWS: lazy(() => import('../pages/dashboard/website/media/Interviews')),
	CHRONICLES: lazy(() => import('../pages/dashboard/website/media/Chronicles')),
	MATCHES_MEDIA: lazy(() => import('../pages/dashboard/website/media/Matches')),
	PARTNERS: lazy(() => import('../pages/dashboard/website/media/Partners')),
	AWARDS: lazy(() => import('../pages/dashboard/website/media/Awards')),
	WINNER_TEAMS: lazy(() => import('../pages/dashboard/website/media/WinnerTeams')),
	BROADCAST: lazy(() => import('../pages/dashboard/website/media/Broadcast')),
	LEGENDS: lazy(() => import('../pages/dashboard/website/media/Legends')),
	PARTNERS_CATEGORIES: lazy(() => import('../pages/dashboard/website/media/PartnersCategory')),
	MENUS_CONFIG: lazy(() => import('../pages/dashboard/website/menus/MenusConfiguration')),
	MENU_ITEMS: lazy(() => import('../pages/dashboard/website/menus/MenuItems')),
	DOCS_ADMINISTRATION: lazy(
		() =>
			import('../pages/dashboard/app-administration/docs-administration/DocsAdministration'),
	),
	DOCUMENTATION: lazy(
		() => import('../pages/dashboard/app-administration/documentation/Documentation'),
	),
	FAQ: lazy(() => import('../pages/dashboard/app-administration/faq/Faq')),
	FAQ_CATEGORY: lazy(() => import('../pages/dashboard/app-administration/faq/FaqCategory')),
	TRANSFER_MARKET: lazy(() => import('../pages/dashboard/transfer-market/TransferMarketPage')),
	MY_REVIEWS: lazy(() => import('../pages/dashboard/MyReviewsPage')),
	REVIEWS_ADMIN: lazy(
		() => import('../pages/dashboard/app-administration/ReviewsAdministration'),
	),
	PRODUCTS: lazy(() => import('../pages/dashboard/app-administration/marketplace/Products')),
	ORDERS: lazy(() => import('../pages/dashboard/app-administration/marketplace/Orders')),
	PRODUCT_CATEGORIES: lazy(
		() => import('../pages/dashboard/app-administration/marketplace/ProductCategories'),
	),
	USER_SHOP: lazy(() => import('../pages/dashboard/user-marketplace/UserShop')),
	USER_ORDERS: lazy(() => import('../pages/dashboard/user-marketplace/UserOrder')),
	CHECKOUT: lazy(() => import('../pages/dashboard/user-marketplace/Checkout')),
	USER_SUSTAIN_TEAM: lazy(() => import('../pages/dashboard/my-teams/UserSustainTeam')),
};

const COLLECTOR = {
	COLLECTION_SHEETS: lazy(() => import('../pages/dashboard/collector/CollectionSheets')),
	CONFIRM_COLLECTION: lazy(() => import('../pages/confirm/ConfirmCollection')),
};

const ACCOUNT = {
	SETTINGS: lazy(() => import('../pages/dashboard/management-account/AccountSettings')),
	YOUR_DOCUMENTS: lazy(() => import('../pages/dashboard/management-account/YourDocuments')),
	YOUR_TEAMS: lazy(() => import('../pages/dashboard/management-account/YourTeams')),
	YOUR_PAYMENTS: lazy(() => import('../pages/dashboard/management-account/YourPayments')),
	ADD_PLAYERS: lazy(() => import('../pages/dashboard/management-account/AddPlayers')),
	YOUR_TRANSFERS: lazy(() => import('../pages/dashboard/management-account/YourTransfers')),
	TEAM_LOT: lazy(() => import('../pages/dashboard/management-account/TeamLot')),
	CARDS_SUSPENDS: lazy(() => import('../pages/dashboard/management-account/CardsAndSuspends')),
	COMPANIES: lazy(() => import('../pages/dashboard/management-account/YourCompanies')),
};

const AUTH = {
	PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
};

const presentation = [
	/**
	 * Landing
	 */
	{
		path: dashboardMenu.dashboard.path,
		element: <LANDING.DASHBOARD />,
		exact: true,
		roles: ['ALL'],
	},
	{
		path: dashboardMenu.youtube.path,
		element: <LANDING.YOUTUBE_LIVE />,
		exact: true,
		roles: ['ALL'],
	},
	{
		path: dashboardMenu.review.path,
		element: <LANDING.MY_REVIEWS />,
		exact: true,
		roles: ['ALL'],
	},
	{
		path: demoPages.page404.path,
		element: <AUTH.PAGE_404 />,
		exact: true,
		roles: ['ALL'],
	},
	{
		path: demoPages.login.path,
		element: <Login />,
		exact: true,
		roles: ['ALL'],
	},
	{
		path: demoPages.resetPassword.path,
		element: <ForgottenPassword />,
		exact: true,
		roles: ['ALL'],
	},
	{
		path: demoPages.register.path,
		element: <Register />,
		exact: true,
		roles: ['ALL'],
	},
	{
		path: demoPages.verifyAccount.path,
		element: <VerifyAccount />,
		exact: true,
		roles: ['ALL'],
	},
	{
		path: 'bar',
		element: <BeerIndexWallGate />,
		exact: true,
		roles: ['ALL'],
	},

	/**
	 * App administration Page
	 */

	{
		path: appManagement.managementCompetitions.subMenu.users.path,
		element: <LANDING.USERS />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},
	{
		path: appManagement.managementCompetitions.subMenu.transfers.path,
		element: <LANDING.TRANSFERS />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},
	{
		path: appManagement.managementCompetitions.subMenu.footballTeams.path,
		element: <LANDING.TEAMS />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},
	{
		path: appManagement.managementCompetitions.subMenu.competitions.path,
		element: <LANDING.COMPETITIONS />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},
	{
		path: appManagement.managementCompetitions.subMenu.cupManagement.path,
		element: <LANDING.CUP_MANAGEMENT />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},
	{
		path: appManagement.managementCompetitions.subMenu.editionJournal.path,
		element: <LANDING.EDITION_JOURNAL />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},
	{
		path: appManagement.managementCompetitions.subMenu.docs.path,
		element: <LANDING.DOCS_ADMINISTRATION />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},
	{
		path: appManagement.managementCompetitions.subMenu.documentation.path,
		element: <LANDING.DOCUMENTATION />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},
	{
		path: appManagement.marketplace.subMenu.products.path,
		element: <LANDING.PRODUCTS />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},
	{
		path: appManagement.marketplace.subMenu.orders.path,
		element: <LANDING.ORDERS />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},
	{
		path: '/management/marketplace/product-categories',
		element: <LANDING.PRODUCT_CATEGORIES />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},
	{
		path: '/management/competitions/editions',
		element: <LANDING.EDITIONS />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},
	{
		path: '/management/competitions/editions/leagues',
		element: <LANDING.LEAGUES />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},
	{
		path: '/management/competitions/editions/leagues/administrate',
		element: <LANDING.ADMINISTRATE_LEAGUE />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},
	{
		path: '/management/cup/tour-management',
		element: <LANDING.TOUR_MANAGEMENT />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},
	{
		path: '/management/cup/tour-administration',
		element: <LANDING.TOUR_ADMINISTRATION />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},
	{
		path: '/management/general-settings',
		element: <LANDING.GENERAL_SETTINGS />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},
	{
		path: '/management/crm',
		element: <Navigate to='/management/crm/leads' replace />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_OPERATOR'],
	},
	{
		path: '/management/crm/leads',
		element: <LANDING.CRM_PAGE section='leads' />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_OPERATOR'],
	},
	{
		path: '/management/crm/signed-teams',
		element: <LANDING.CRM_PAGE section='signed-teams' />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},
	{
		path: '/management/crm/reports',
		element: <LANDING.CRM_PAGE section='reports' />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},
	{
		path: '/management/crm/editions',
		element: <LANDING.CRM_PAGE section='editions' />,
		exact: true,
		roles: ['ROLE_SUPER_ADMIN'],
	},
	{
		path: '/management/financial',
		element: <LANDING.FINANCIAL />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},

	/**
	 * Collector (fisa incasari)
	 */
	{
		path: '/collector/fisa-incasari',
		element: <COLLECTOR.COLLECTION_SHEETS />,
		exact: true,
		roles: ['ROLE_COLLECTOR', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},
	{
		path: '/confirm-collection/:token',
		element: <COLLECTOR.CONFIRM_COLLECTION />,
		exact: true,
		roles: ['ALL'],
	},

	{
		path: '/management/disciplinary',
		element: <LANDING.DISCIPLINARY />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_ORGANIZER'],
	},
	{
		path: matchStatisticsManage.matchStatistics.path,
		element: <LANDING.MATCH_STATISTICS />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_ORGANIZER'],
	},
	{
		path: '/management/reviews-administration',
		element: <LANDING.REVIEWS_ADMIN />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},

	/**
	 * Manage Match Events
	 */

	{
		path: matchManagements.matchEvents.path,
		element: <LANDING.MATCH_EVENTS />,
		exact: true,
		roles: ['ROLE_ADMIN'],
	},
	{
		path: '/match-management/events/match-details',
		element: <LANDING.MATCH_EVENT_DETAILS />,
		exact: true,
		roles: ['ALL'],
	},
	{
		path: '/match-management/events/lineup',
		element: <LANDING.LINEUP />,
		exact: true,
		roles: ['ALL'],
	},

	/**
	 * Account Management Page
	 */

	{
		path: administrationAccount.account.path,
		element: <ACCOUNT.SETTINGS />,
		exact: true,
		roles: ['ROLE_MANAGER'],
	},

	{
		path: administrationAccount.teams.path,
		element: <ACCOUNT.YOUR_TEAMS />,
		exact: true,
		roles: ['ROLE_MANAGER'],
	},

	{
		path: administrationAccount.accountDocuments.path,
		element: <ACCOUNT.YOUR_DOCUMENTS />,
		exact: true,
		roles: ['ROLE_MANAGER'],
	},

	{
		path: documentsPlayer.transferMarkets.path,
		element: <LANDING.TRANSFER_MARKET />,
		exact: true,
		roles: ['ALL'],
	},
	// Vechea pagina a jucatorilor duce in Transfer market 2.0
	{
		path: '/management-account/transfer-market',
		element: <LANDING.TRANSFER_MARKET />,
		exact: true,
		roles: ['ROLE_PLAYER', 'ROLE_DELEGATE'],
	},
	// Moderarea Transfer market e acum tab in Transferuri; linkurile vechi ajung acolo
	{
		path: '/management/transfer-market',
		element: <Navigate to={`${appManagement.managementCompetitions.subMenu.transfers.path}?tab=moderation`} replace />,
		exact: true,
		roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
	},

	{
		path: administrationAccount.players.path,
		element: <ACCOUNT.ADD_PLAYERS />,
		exact: true,
		roles: ['ROLE_MANAGER'],
	},

	{
		path: administrationAccount.transfers.path,
		element: <ACCOUNT.YOUR_TRANSFERS />,
		exact: true,
		roles: ['ROLE_MANAGER'],
	},

	{
		path: administrationAccount.teamLot.path,
		element: <ACCOUNT.TEAM_LOT />,
		exact: true,
		roles: ['ROLE_MANAGER'],
	},
	{
		path: administrationAccount.manageDisciplinary.path,
		element: <ACCOUNT.CARDS_SUSPENDS />,
		exact: true,
		roles: ['ROLE_MANAGER'],
	},

	{
		path: administrationAccount.financial.path,
		element: <ACCOUNT.YOUR_PAYMENTS />,
		exact: true,
		roles: ['ROLE_MANAGER', 'ROLE_DELEGATE'],
	},

	{
		path: administrationAccount.company.path,
		element: <ACCOUNT.COMPANIES />,
		exact: true,
		roles: ['ROLE_MANAGER'],
	},
	/** ************************************************** */

	/**
	 * Site Administration
	 */

	{
		path: administrationSite.media.subMenu.news.path,
		element: <LANDING.NEWS />,
		exact: true,
		roles: ['ROLE_ADMIN'],
	},
	{
		path: administrationSite.media.subMenu.interviews.path,
		element: <LANDING.INTERVIEWS />,
		exact: true,
		roles: ['ROLE_ADMIN'],
	},
	{
		path: administrationSite.media.subMenu.chronicles.path,
		element: <LANDING.CHRONICLES />,
		exact: true,
		roles: ['ROLE_ADMIN'],
	},
	{
		path: administrationSite.media.subMenu.matches.path,
		element: <LANDING.MATCHES_MEDIA />,
		exact: true,
		roles: ['ROLE_ADMIN'],
	},
	{
		path: administrationSite.media.subMenu.broadcastChannels.path,
		element: <LANDING.BROADCAST />,
		exact: true,
		roles: ['ROLE_ADMIN'],
	},
	{
		path: administrationSite.media.subMenu.partners.path,
		element: <LANDING.PARTNERS />,
		exact: true,
		roles: ['ROLE_ADMIN'],
	},
	{
		path: administrationSite.media.subMenu.awards.path,
		element: <LANDING.AWARDS />,
		exact: true,
		roles: ['ROLE_ADMIN'],
	},
	{
		path: administrationSite.media.subMenu.legends.path,
		element: <LANDING.LEGENDS />,
		exact: true,
		roles: ['ROLE_ADMIN'],
	},
	{
		path: administrationSite.media.subMenu.winnerTeams.path,
		element: <LANDING.WINNER_TEAMS />,
		exact: true,
		roles: ['ROLE_ADMIN'],
	},
	{
		path: administrationSite.questions.path,
		element: <LANDING.FAQ />,
		exact: true,
		roles: ['ROLE_ADMIN'],
	},
	{
		path: '/questions/categories',
		element: <LANDING.FAQ_CATEGORY />,
		exact: true,
		roles: ['ROLE_ADMIN'],
	},
	{
		path: '/media/partners-categories',
		element: <LANDING.PARTNERS_CATEGORIES />,
		exact: true,
		roles: ['ROLE_ADMIN'],
	},
	{
		path: '/newsletter',
		element: <LANDING.NEWSLETTER />,
		exact: true,
		roles: ['ROLE_ADMIN'],
	},
	{
		path: administrationSite.menus.path,
		element: <LANDING.MENUS_CONFIG />,
		exact: true,
		roles: ['ROLE_ADMIN'],
	},
	{
		path: '/menus/items',
		element: <LANDING.MENU_ITEMS />,
		exact: true,
		roles: ['ROLE_ADMIN'],
	},

	/** ************************************************** */

	/**
	 * Marketplace
	 */

	{
		path: shopManagementUser.shop.path,
		element: <LANDING.USER_SHOP />,
		exact: true,
		roles: ['ALL'],
	},
	{
		path: shopManagementUser.order.path,
		element: <LANDING.USER_ORDERS />,
		exact: true,
		roles: ['ALL'],
	},
	{
		path: shopManagementUser.order.path,
		element: <LANDING.USER_ORDERS />,
		exact: true,
		roles: ['ALL'],
	},
	{
		path: '/user-marketplace/checkout',
		element: <LANDING.CHECKOUT />,
		exact: true,
		roles: ['ALL'],
	},

	/** ************************************************** */

	/**
	 * USER SUSTAIN TEAM
	 */

	{
		path: userTeam.sustain.path,
		element: <LANDING.USER_SUSTAIN_TEAM />,
		exact: true,
		roles: ['ALL'],
	},
];
const contents = [...presentation];

export default contents;
